import { RouterDataLinks } from '@campaign-portal/components-library';
import { ClientsComponent } from '../../pages/clients/clients.component';
import { RulesComponent } from '../../pages/rules/rules.component';
import { SourcesComponent } from '../../pages/sources/sources.component';
import { ProfileComponent } from '../../pages/profile/profile.component';
import { UsersComponent } from '../../pages/users/users.component';
import { RolesComponent } from '../../pages/roles/roles.component';
import { AuthGuard } from '../../auth/auth.guard';
import { SettingsComponent } from '../../pages/settings/settings/settings.component';
import { ImportRatesComponent } from '../../pages/import rates/import-rates.component';
import { ManualDippingComponent } from 'src/app/pages/manual-dipping/manual-dipping.component';
import { ManualDippingViewResultsComponent } from 'src/app/pages/manual-dipping/manual-dipping-view-results/manual-dipping-view-results.component';
import { CurrenciesComponent } from '../../pages/settings/currencies/currencies.component';
import { RatesComponent } from '../../pages/settings/rates/rates.component';
import { SystemCodesComponent } from '../../pages/response-code-translations/system-codes/system-codes.component';
import { TranslationRulesComponent } from '../../pages/response-code-translations/translation-rules/translation-rules.component';

export const SignInLink = 'sign-in';

export const routerLinks: Readonly<RouterDataLinks> = {
	sources: {
		canActivate: [AuthGuard],
		path: 'sources',
		component: SourcesComponent,
		data: {
			permissions: ['sources.read'],
			title: 'sources.title',
			icon: 'show_chart',
			animationState: 'SourcesComponent'
		}
	},
	clients: {
		canActivate: [AuthGuard],
		path: 'clients',
		component: ClientsComponent,
		data: {
			permissions: ['clients.read'],
			title: 'clients.title',
			icon: 'group',
			animationState: 'ClientsComponent'
		}
	},
	rules: {
		canActivate: [AuthGuard],
		path: 'rules',
		component: RulesComponent,
		data: {
			permissions: ['rules.read'],
			title: 'rules.title',
			icon: 'rule',
			animationState: 'RulesComponent'
		}
	},
	settings: {
		canActivate: [AuthGuard],
		path: 'settings',
		data: {
			permissions: ['settings.read'],
			title: 'settings.title',
			icon: 'settings',
			animationState: 'SettingsComponent'
		},
		children: [
			{
				path: 'settings',
				component: SettingsComponent,
				data: {
					permissions: ['settings.read', 'settings.edit'],
					title: 'settings.title',
					icon: 'icon-settings',
					animationState: 'SettingsComponent'
				}
			},
			{
				path: 'currencies',
				component: CurrenciesComponent,
				data: {
					permissions: ['currencies.read'],
					title: 'currencies.title',
					icon: 'icon-money-1',
					animationState: 'CurrenciesComponent'
				}
			},
			{
				path: 'rates',
				component: RatesComponent,
				data: {
					permissions: ['rates.read'],
					title: 'rates.title',
					icon: 'icon-rate',
					animationState: 'RatesComponent'
				}
			}
		]
	},
	import_rates: {
		canActivate: [AuthGuard],
		path: 'import_rates',
		component: ImportRatesComponent,
		data: {
			permissions: ['import_rates.read'],
			title: 'import_rates.title',
			icon: 'icon-rate',
			animationState: 'ImportRatesComponent'
		}
	},
	manual_dipping: {
		canActivate: [AuthGuard],
		path: 'manual_dipping',
		component: ManualDippingComponent,
		data: {
			permissions: ['mdtask.read'],
			title: 'manual_dipping.title',
			icon: 'icon-paper-plane-tilt',
			animationState: 'ManualDippingComponent'
		}
	},
	manual_dipping_results: {
		canActivate: [AuthGuard],
		path: 'manual_dipping_results/:id',
		component: ManualDippingViewResultsComponent,
		data: {
			permissions: ['mdtask.read'],
			title: 'manual_dipping.title',
			icon: 'icon-paper-plane-tilt',
			animationState: 'ManualDippingViewResultsComponent',
			hiddenMenu: true,
			backRoute: true
		}
	},
	response_code_translations: {
		canActivate: [AuthGuard],
		path: 'response_code_translations',
		data: {
			permissions: ['system_codes.read', 'translation_rules.read'],
			title: 'response_code_translations.title',
			icon: 'translation_rule',
			animationState: 'ResponseCodeTranslationsComponent'
		},
		children: [
			{
				canActivate: [AuthGuard],
				path: 'system_codes',
				component: SystemCodesComponent,
				data: {
					permissions: ['system_codes.read'],
					title: 'system_codes.title',
					icon: 'system_codes',
					animationState: 'SystemCodesComponent'
				}
			},
			{
				canActivate: [AuthGuard],
				path: 'translation_rules',
				component: TranslationRulesComponent,
				data: {
					permissions: ['translation_rules.read'],
					title: 'translation_rules.title',
					icon: 'translation_rule',
					animationState: 'TranslationRulesComponent'
				}
			}
		]
	},
	users: {
		canActivate: [AuthGuard],
		path: 'users',
		component: UsersComponent,
		data: {
			permissions: ['users.read'],
			title: 'users_roles.users.title',
			icon: 'manage_accounts',
			animationState: 'UsersComponent'
		}
	},
	roles: {
		canActivate: [AuthGuard],
		path: 'roles',
		component: RolesComponent,
		data: {
			permissions: ['roles.read'],
			title: 'users_roles.roles.title',
			icon: 'icon-users',
			animationState: 'RolesComponent'
		}
	},
	profile: {
		canActivate: [AuthGuard],
		path: 'profile',
		component: ProfileComponent,
		data: {
			permissions: ['profile.edit'],
			title: 'users_roles.users.profile',
			icon: 'account_circle',
			animationState: 'ProfileComponent',
			hiddenMenu: true
		}
	}
};
